Object.isDate = function (obj) {
    return obj && Object.prototype.toString.call(obj) === "[object Date]" && !isNaN(obj);
};
Object.isDefined = function (obj) {
    return typeof obj != "undefined" && obj != null;
};
Object.isArray = function (obj) {
    return typeof obj === "object" && obj instanceof Array;
};
Object.isObject = function (obj) {
    return typeof obj === "object" && (Array.isArray(obj) === false);
};
Object.isNumber = function (obj) {
    return typeof obj === "number";
};
Object.isString = function (obj) {
    return typeof obj === "string";
};
Object.isBoolean = function (obj) {
    return typeof obj === "boolean";
};
Object.isEmpty = function (obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop))
            return false;
    }
    return JSON.stringify(obj) === JSON.stringify({});
};
Object.toArray = function (obj) {
    if (!Array.isArray(obj))
        return [obj];
    return obj;
};
Object.merge = function (a, b) {
    a = Object.clone(a);
    b = Object.clone(b);
    let c = a;
    //merge recursively b on c
    for (let p in b) {
        if (b.hasOwnProperty(p)) {
            if (Object.isObject(b[p])) {
                if (!a[p]) {
                    a[p] = {};
                }
                c[p] = Object.merge(a[p], b[p]);
            }
            else if (Object.isArray(b[p])) {
                c[p] = a[p] ? a[p].concat(b[p]) : b[p];
            }
            else {
                c[p] = b[p];
            }
        }
    }
    return c;
};
Object.clone = function (a) {
    var c = {};
    for (var p in a) {
        if (a.hasOwnProperty(p)) {
            c[p] = _clone(a[p]);
        }
    }
    function _clone(x) {
        if (Object.isObject(x)) {
            var temp = {};
            for (var p in x) {
                if (x.hasOwnProperty(p)) {
                    temp[p] = _clone(x[p]);
                }
            }
            return temp;
        }
        else if (Object.isArray(x)) {
            var arr = [];
            for (var p in x) {
                if (x.hasOwnProperty(p)) {
                    arr.push(_clone(x[p]));
                }
            }
            return arr;
        }
        else {
            return x;
        }
    }
    return c;
};
Object.param = function (values, prefix) {
    let str = [];
    for (let key in values) {
        let val = values[key];
        let k = key;
        if (prefix) {
            if (values instanceof Array) {
                k = prefix + "[]";
            }
            else {
                k = prefix + "[" + key + "]";
            }
        }
        switch (typeof val) {
            case 'string':
            case 'number':
                str[str.length] = encodeURIComponent(k) + '=' + encodeURIComponent(val.toString());
                break;
            case 'object':
                str[str.length] = Object.param(val, k);
        }
    }
    return str.join("&");
};
